import * as React from 'react';
import { Typography, TypographyProps } from 'omakase';
import {
  container,
  titleContainer,
  title as titleCss,
} from 'consumer-page-widgets/cardTypeCssDefs';

interface Props {
  title: React.ReactNode;
  titleProps?: Optional<TypographyProps>;
  titleLines?: number;
  subtitle?: React.ReactNode;
  subtitleProps?: Optional<TypographyProps>;
  gutterBottom?: boolean;
  reverse?: boolean;
}

export const CardTitle: React.FunctionComponent<Props> = ({
  title,
  titleProps,
  titleLines = 2,
  subtitle,
  subtitleProps,
  gutterBottom,
  reverse = false,
}) => {
  return (
    <section css={(theme) => container(theme, !!gutterBottom)}>
      <section css={(theme) => titleContainer(theme, !!subtitle)} data-testid="result-title">
        <Typography
          css={() => titleCss(titleLines)}
          variant={reverse ? 'body02' : 'body01Strong'}
          component={reverse ? 'p' : 'h3'}
          color="fgDefault"
          {...titleProps}
        >
          {title}
        </Typography>
      </section>
      {subtitle && (
        <Typography
          color="fgDefault"
          variant={reverse ? 'body01Strong' : 'body02'}
          component={reverse ? 'h3' : 'p'}
          {...subtitleProps}
          data-testid="sub-title"
        >
          {subtitle}
        </Typography>
      )}
    </section>
  );
};
